import React from 'react'
import styled from 'styled-components'
import { LandUsePlanDocument } from '@popety-io/types'
import { DocumentItem } from './DocumentItem'

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xsmall};
`

const EmptyState = styled.div`
  padding: ${({ theme }) => theme.spacing.large};
  text-align: center;
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
`

interface DocumentsListProps {
  documents: LandUsePlanDocument[]
  emptyMessage?: string
}

export const DocumentsList: React.FC<DocumentsListProps> = ({
  documents,
  emptyMessage = 'No documents available',
}) => {
  if (documents.length === 0) {
    return <EmptyState>{emptyMessage}</EmptyState>
  }

  return (
    <ListContainer>
      {documents.map((document) => (
        <DocumentItem key={document.id} document={document} />
      ))}
    </ListContainer>
  )
}
